import { useState, useCallback, useEffect } from "react";
import { jobDataManager } from "../services/jobDataManager";
import { isComplete } from "../utils/job-status.utils";
import { useJobNotifications } from "./useJobNotifications";
import { useJobQuery } from "./useJobsQuery";
import type { Job, PushedJob } from "../types/jobs.types";

export const useJobData = (initJob: Job | null) => {
  const getJobFromPusher = (): PushedJob | null => initJob?.uuid ? jobDataManager.getPushedJob(initJob.uuid) : null;
  const [jobFromPusher, setJobFromPusher] = useState<PushedJob | null>(() => getJobFromPusher());

  const { data, refetch } = useJobQuery(initJob?.uuid ?? "");
  const jobFromApi = data?.job ?? initJob;

  const handleJobUpdate = useCallback(() => {
    if (!jobFromApi) return;
    setJobFromPusher(getJobFromPusher());
  }, [jobFromApi]);

  useJobNotifications(jobFromApi?.uuid, handleJobUpdate);

  useEffect(() => {
    if (!jobFromPusher || !isComplete(jobFromPusher)) return;
    refetch();
  }, [jobFromPusher?.status_code]);

  if (!jobFromApi) return {
    mergedJob: null,
    hasUpdates: false,
  };

  return {
    mergedJob: isComplete(jobFromApi) ? jobFromApi : { ...jobFromApi, ...jobFromPusher },
    hasUpdates: !!jobFromApi?.uuid && !!jobFromPusher,
  };
};
